import React from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import * as Const from "./../_Const";

const InfoMessage = ({ title, message1, message2, className, align }) => {
  const max375 = useMediaQuery("(max-width: 375px)");
  const max300 = useMediaQuery("(max-width: 300px)");

  const isTerminal = Const.isTerminal();
  const textCss = isTerminal ? "text-4xl" : "text-2xl mt-5";
  const textCss2 = isTerminal ? "text-3xl " : "text-xl";

  function getFontSize() {
    let font;
    if (isTerminal) {
      font = "text-6xl";
    } else {
      if (max300) {
        font = "text-xl";
      } else if (max375) {
        font = "text-2xl";
      } else {
        font = "text-[1.92rem]";
      }
    }
    return font;
  }

  return (
    <>
      <div className="bg-accent-secondary mt-8 mx-6 h-36 flex justify-center items-center">
        <p className={`${getFontSize()} text-accent-dark uppercase`}>{title}</p>
      </div>
      <h1 className={`${textCss} ${className} ${align} font-black text-accent-dark dark:text-accent mx-6`}>{message1}</h1>
      <p className={`mx-6 mt-1 ${textCss2} ${align} text-primary`}>{message2}</p>
    </>
  );
};
export default InfoMessage;
